// The Funnel section's cohort-window vocabulary. The values are the generated
// `FunnelPresetWindow` wire union — what `GET /api/admin/funnel?window=`
// actually accepts — so renaming one on the backend fails typecheck here; this
// module adds the display order, labels, and the URL-param parser shared by the
// route and the page.
//
// Deliberately NOT `FunnelWindow`, which is the wider union a funnel PAYLOAD can
// report and also carries `custom`. A custom range is not a preset somebody can
// ask this route for: it is computed on demand on its own route
// (`/funnel/range?from=&to=`), and the page holds it as a `DateRange` rather
// than as a fifth switcher value. Typing the switcher on the payload union would
// mean inventing a label and a `?window=custom` link for a request the backend
// can only answer with a 503.
import type { FunnelPresetWindow } from "@recruiter/shared/types";

export const FUNNEL_WINDOWS: readonly FunnelPresetWindow[] = ["7d", "30d", "90d", "all"];

export const FUNNEL_WINDOW_LABELS: Record<FunnelPresetWindow, string> = {
  "7d": "Last 7 days",
  "30d": "Last 30 days",
  "90d": "Last 90 days",
  // horizon-allow: a user-chosen window, not a claim about the data
  all: "All time",
};

export function isFunnelWindow(value: unknown): value is FunnelPresetWindow {
  return typeof value === "string" && (FUNNEL_WINDOWS as readonly string[]).includes(value);
}

/** `?window=` parser: a known preset or absent (the route defaults to "all"). */
export function parseFunnelWindow(value: unknown): FunnelPresetWindow | undefined {
  return isFunnelWindow(value) ? value : undefined;
}

export type { FunnelPresetWindow };
